import api from 'api/apiInstance';

export function blogPostEmailClientsApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
